import styled from 'styled-components';
import { Panel, Table } from 'react-bootstrap';

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
        padding: 2px 5px 0px 5px;
    }

    & > tbody > tr > td {
        text-align: center;
        padding: 5px;
    }

    & > tbody > tr > td:nth-child(2) {
        text-align: left;
        padding-left: 15px;
    }

    & > tbody > tr > td:nth-child(1) {
        width: 30px;
    }
`;

export const PanelWrapper = styled(Panel)`
    & > .panel-heading {
        padding: 7.5px 15px;
    }

    & > .panel-heading > .panel-title {
        cursor: pointer;
    }

    & > .panel-heading > .panel-title:hover {
        text-decoration: underline;
    }
`;

export const CenterPerformanceWrapper = styled.div`
    padding-top: 5px;

    .panel-heading {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    #data-compliance > .panel > .panel-body .panel-title {
        font-size: 14px;
    }

    .loader {
        position: absolute;
        top: 200px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        //width: 98%;
        //height: 87%;
        // background-color: #eceaea;
        background-image: url('/images/ajax-loader.gif');
        background-size: 50px;
        background-repeat: no-repeat;
        background-position: center;
        z-index: 10000000;
        // opacity: 0.45;
        // border: 1px solid red;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        // background-color: #eee;
        // opacity: 0.5;
    }

    .loader > .message {
        z-index: 10000001;
        padding-top: 75px;
        font-weight: normal;
        color: black;
        font-size: 16px;
        // opacity: 1;
    }
`;